import { Component, OnInit, TemplateRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Observable, forkJoin, of } from "rxjs";
import { catchError, filter, map } from "rxjs/operators";
import { HttpEventType } from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import {
  CapacitacionActividad,
  CapacitacionActividadPayload,
  CapacitacionActividadService,
} from "../../../../../../../shared/services/capacitacion-actividad.service";

import {
  CapacitacionActividadRe,
  CapacitacionActividadRePayload,
  CapacitacionActividadReService,
} from "../../../../../../../shared/services/capacitacion-actividadre.service";

import {
  CapacitacionView,
  CapacitacionesService,
} from "../../../../../../../shared/services/capacitacion.service";

import { Utils } from "../../../../../../../shared/utils/Utils";
import { CargosService } from "../../../../../../../shared/services/cargos.service";
import { CapacitacionProgramacionService } from "../../../../../../../shared/services/capacitaciones_programacion.service";
import { PropietarioService } from "../../../../../../../shared/services/propietarios.service";
import {
  CapacitacionActividadEjecucion,
  CapacitacionActividadEjecucionPayload,
  CapacitacionActividadEjecucionService,
} from "../../../../../../../shared/services/capacitacion-actividad-ejecucion.service";
import { DigitalesService } from "../../../../../../../shared/services/digitales.service";
import { AdministracionService } from "../../../../../../../shared/services/administracion.services";
import { AuthService } from "../../../../../../../shared/services/auth.service";

declare var require: any;
const Swal = require("sweetalert2");

interface SubActividadRow {
  id?: number;
  actividad: string;
}

interface DocumentoAdjunto {
  path: string;
  name: string;
  url: string;
  isImage: boolean;
}

interface ArchivoPendiente {
  file: File;
  preview: string | null;
}

interface DocumentoPreview {
  name: string;
  path: string;
  url: string;
  urlSegura?: SafeResourceUrl;
  isImage: boolean;
  isPdf: boolean;
  tipo: string;
}

const EXTENSIONES_IMAGEN = ["jpg", "jpeg", "png", "webp"];
const MIME_IMAGEN = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

@Component({
  selector: 'app-actividades',
  templateUrl: './actividades.component.html',
  styleUrls: ['./actividades.component.scss']
})
export class ActividadesComponent implements OnInit {
  loading = false;
  searchText = "";
  stateFilter: "all" | "active" | "inactive" = "all";
  pageSize = 5;
  page = 1;
  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";

  actividades: CapacitacionActividad[] = [];
  filteredTableItems: CapacitacionActividad[] = [];
  capacitaciones: CapacitacionView[] = [];

  idCapacitacionRuta: number | null = null;

  modalRef?: NgbModalRef;
  modoEdicion = false;
  actividadEditandoId: number | null = null;
  propietarios: any[] = [];

  actividadForm: CapacitacionActividadPayload = this.formVacio();
  responsables: any[] = [];

  subActividades: SubActividadRow[] = [];
  subActividadesEliminadas: number[] = [];
  rangoProgramacion: { fecha_inicio?: string; fecha_final?: string } = {};

  // ==========================================================
  // SEGUIMIENTOS: listado tabular (mismo patrón que PasosPlanComponent)
  // ==========================================================
  modalSeguimientosRef?: NgbModalRef;
  idActividadSeguimientos: number | null = null;
  nombreActividadSeguimientos: string = "";
  listaSeguimientos: CapacitacionActividadEjecucion[] = [];
  cargandoSeguimientos = false;

  seguimientoForm!: FormGroup;
  seguimientoEditando: CapacitacionActividadEjecucion | null = null;
  guardandoSeguimiento = false;

  // ==========================================================
  // DOCUMENTOS DEL SEGUIMIENTO SELECCIONADO
  // Ruta: {nit}/capacitaciones/{idCapacitacion}/{idActividad}/seguimientos/{idSeguimiento}
  // ==========================================================
  nit: string = "";
  seguimientoSeleccionadoDocs: CapacitacionActividadEjecucion | null = null;
  documentosSeguimiento: DocumentoAdjunto[] = [];
  nuevosArchivosDocs: ArchivoPendiente[] = [];
  cargandoDocumentos = false;
  subiendoDocumentos = false;

  documentoSeleccionado: DocumentoPreview | null = null;
  mostrandoPreviewDocumento = false;
  nombreCapacitacionRuta: string = "";
  actividadSeguimientosActiva: boolean = true; // 👈 nuevo

  constructor(
    private fb: FormBuilder,
    private actividadService: CapacitacionActividadService,
    private actividadReService: CapacitacionActividadReService,
    private capacitacionesService: CapacitacionesService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private digitalesService: DigitalesService,
    private administracionService: AdministracionService,
    private cargosService: CargosService,
    private programacionService: CapacitacionProgramacionService,
    private propietarioService: PropietarioService,
    private actividadEjecucionService: CapacitacionActividadEjecucionService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get("id");
    this.idCapacitacionRuta = idParam ? Number(idParam) : null;

    this.inicializarFormSeguimiento();
    this.cargarCapacitaciones();
    this.cargarActividades();
    this.cargarResponsable();
    this.cargarPropietarios();
    this.cargarRangoProgramacion();

    const usuario = this.authService.getCurrentUserValue();
    this.nit = usuario?.nit ?? usuario?.empresa?.nit ?? "";

    if (!this.nit) {
      this.obtenerNit();
    }
  }

cargarRangoProgramacion(): void {
  if (!this.idCapacitacionRuta) return;
  this.programacionService.getCapacitacionFechas(this.idCapacitacionRuta).subscribe({
    next: (data) => {
      this.rangoProgramacion = {
        fecha_inicio: data.fecha_inicio ? String(data.fecha_inicio).substring(0, 10) : undefined,
        fecha_final:  data.fecha_final  ? String(data.fecha_final).substring(0, 10)  : undefined,
      };
      this.nombreCapacitacionRuta = data.capacitacion?.nombre ?? "";
    },
    error: () => {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar el rango de fechas de la programación" });
    },
  });
}

  // ── Helpers ──────────────────────────────────────────────────
  private formVacio(): CapacitacionActividadPayload {
    return {
      id_capacitacion: this.idCapacitacionRuta ?? (undefined as any),
      dirigido: undefined as any,
      responsable: undefined as any,
      fecha_programacion: undefined as any,
      fecha_ejecucion: undefined as any,
      hora_inicio: undefined as any,
      hora_fin: undefined as any,
      estado: 1,
    };
  }

  private obtenerNit(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (admins: any[]) => {
        this.nit = admins?.[0]?.nit != null ? String(admins[0].nit) : "";
      },
      error: () => {
        this.nit = "";
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener el NIT de la empresa." });
      },
    });
  }

  esActivo(item: CapacitacionActividad): boolean {
    return Number(item?.estado ?? 1) !== 0;
  }

  obtenerNombreCapacitacion(idCapacitacion: number | null): string {
    if (!idCapacitacion) return "";
    const cap = this.capacitaciones.find((c) => Number(c.id) === Number(idCapacitacion));
    return cap?.nombre ?? "";
  }

  obtenerSubActividadesActivas(item: any): CapacitacionActividadRe[] {
    return (item?.CapacitacionActividadReData ?? []).filter(
      (s: CapacitacionActividadRe) => Number(s.estado ?? 1) !== 0,
    );
  }

  trackByIndex(index: number): number {
    return index;
  }

  trackBySeguimientoId(_index: number, seguimiento: CapacitacionActividadEjecucion): number | undefined {
    return seguimiento.id;
  }

  // ── Carga de datos ───────────────────────────────────────────
  cargarCapacitaciones(): void {
    this.capacitacionesService.getAllCapacitacionesActivos().subscribe({
      next: (data) => {
        this.capacitaciones = (data ?? []).filter(
          (c: CapacitacionView) => Number(c.estado ?? 1) !== 0,
        );
      },
      error: () => {
        Swal.fire({ icon: "error", title: "No se pudieron cargar las capacitaciones", text: "Intenta nuevamente." });
      },
    });
  }

  cargarResponsable(): void {
    this.cargosService.getCargosActivos().subscribe({
      next: (data) => { this.responsables = data; },
      error: () => {
        Swal.fire({ icon: "error", title: "No se pudieron cargar los cargos", text: "Intenta nuevamente." });
      },
    });
  }

  cargarPropietarios(): void {
    this.propietarioService.getPlanAccion().subscribe({
      next: (data) => { this.propietarios = data; },
      error: () => {
        Swal.fire({ icon: "error", title: "No se pudieron cargar los cargos", text: "Intenta nuevamente." });
      },
    });
  }

  cargarActividades(): void {
    if (!this.idCapacitacionRuta) return;
    this.loading = true;
    this.actividadService.getByIdCapacitacion(this.idCapacitacionRuta).subscribe({
      next: (data) => {
        this.actividades = data ?? [];
        this.filterData();
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }

  filterData(): void {
    const term = this.searchText.trim().toLowerCase();

    const base = [...this.actividades].filter((item) => {
      if (this.stateFilter === "active") return this.esActivo(item);
      if (this.stateFilter === "inactive") return !this.esActivo(item);
      return true;
    });

    this.filteredTableItems = !term
      ? base
      : base.filter((item: any) => {
          const nombreCap = (
            item.capacitacion?.nombre ?? this.obtenerNombreCapacitacion(item.id_capacitacion)
          ).toLowerCase();
          const estado = this.esActivo(item) ? "activo" : "inactivo";
          const id = String(item.id ?? "").toLowerCase();
          return nombreCap.includes(term) || estado.includes(term) || id.includes(term);
        });

    this.sortCurrentData();
  }

  // ── Ordenamiento ─────────────────────────────────────────────
  sortData(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }
    this.sortCurrentData();
  }

  private sortCurrentData(): void {
    if (!this.sortColumn) return;
    this.filteredTableItems.sort((a: any, b: any) => {
      const vA = (a?.[this.sortColumn] ?? "").toString().toLowerCase();
      const vB = (b?.[this.sortColumn] ?? "").toString().toLowerCase();
      if (vA < vB) return this.sortDirection === "asc" ? -1 : 1;
      if (vA > vB) return this.sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }

  // ── Modal único: crear / editar ──────────────────────────────
  abrirModalNuevo(content: TemplateRef<any>): void {
    this.modoEdicion = false;
    this.actividadEditandoId = null;
    this.actividadForm = this.formVacio();
    this.subActividades = [{ actividad: "" }];
    this.subActividadesEliminadas = [];

    this.modalRef = this.modalService.open(content, { centered: true, size: "xl", backdrop: "static" });
  }

  abrirModalEditar(item: CapacitacionActividad, content: TemplateRef<any>): void {
    if (!item?.id) return;
    this.loading = true;

    this.actividadService.getById(Number(item.id)).subscribe({
      next: (data: any) => {
        this.modoEdicion = true;
        this.actividadEditandoId = Number(data.id);

        this.actividadForm = {
          id_capacitacion: this.idCapacitacionRuta ?? Number(data.id_capacitacion),
          dirigido: data.dirigido,
          responsable: data.responsable,
          fecha_programacion: data.fecha_programacion
            ? String(data.fecha_programacion).substring(0, 10)
            : (undefined as any),
          fecha_ejecucion: data.fecha_ejecucion
            ? String(data.fecha_ejecucion).substring(0, 10)
            : (undefined as any),
          hora_inicio: data.hora_inicio ? String(data.hora_inicio).substring(0, 5) : (undefined as any),
          hora_fin: data.hora_fin ? String(data.hora_fin).substring(0, 5) : (undefined as any),
          estado: Number(data.estado ?? 1),
        };

        const embebidas: CapacitacionActividadRe[] | undefined = data.CapacitacionActividadReData;

        if (embebidas) {
          this.setSubActividadesDesde(embebidas);
          this.loading = false;
          this.abrirModal(content);
        } else {
          this.cargarSubActividades(this.actividadEditandoId, content);
        }
      },
      error: (error) => {
        this.loading = false;
        Swal.fire({ icon: "error", title: "Error", text: error?.error?.message || "No se pudo cargar la actividad" });
      },
    });
  }

  private setSubActividadesDesde(data: CapacitacionActividadRe[]): void {
    this.subActividades = (data ?? [])
      .filter((s) => Number(s.estado ?? 1) !== 0)
      .map((s) => ({ id: s.id, actividad: s.actividad }));

    this.subActividadesEliminadas = [];

    if (this.subActividades.length === 0) {
      this.subActividades = [{ actividad: "" }];
    }
  }

  private abrirModal(content: TemplateRef<any>): void {
    this.modalRef = this.modalService.open(content, { centered: true, size: "xl", backdrop: "static" });
  }

  private cargarSubActividades(idActividad: number, content: TemplateRef<any>): void {
    this.actividadReService.getByIdActividad(idActividad).subscribe({
      next: (data) => {
        this.loading = false;
        this.setSubActividadesDesde(data ?? []);
        this.abrirModal(content);
      },
      error: () => {
        this.loading = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar las actividades específicas." });
      },
    });
  }

  // ── Manejo de filas de actividades específicas (actividadre) ────
  agregarSubActividad(): void {
    this.subActividades.push({ actividad: "" });
  }

  eliminarSubActividad(index: number): void {
    const fila = this.subActividades[index];
    if (fila?.id) {
      this.subActividadesEliminadas.push(fila.id);
    }
    this.subActividades.splice(index, 1);

    if (this.subActividades.length === 0) {
      this.subActividades.push({ actividad: "" });
    }
  }

  // ── Guardar (cabecera + intermedia) ──────────────────────────
  guardarActividad(): void {
    if (!this.idCapacitacionRuta) {
      this.mostrarAlerta("Error", "No se encontró la capacitación en la URL", "error");
      return;
    }
    if (!this.actividadForm.dirigido) {
      this.mostrarAlerta("Campo requerido", "Ingrese a quién va dirigido", "info");
      return;
    }
    if (!this.actividadForm.responsable) {
      this.mostrarAlerta("Campo requerido", "Seleccione el responsable", "info");
      return;
    }
    if (!this.actividadForm.fecha_programacion) {
      this.mostrarAlerta("Campo requerido", "Ingrese la fecha de programación", "info");
      return;
    }

    const subActividadesValidas = this.subActividades.filter((s) => s.actividad?.trim());
    if (subActividadesValidas.length === 0) {
      this.mostrarAlerta("Campo requerido", "Agregue al menos una actividad específica", "info");
      return;
    }

    const { fecha_inicio, fecha_final } = this.rangoProgramacion;

    if (fecha_inicio && this.actividadForm.fecha_programacion < fecha_inicio) {
      this.mostrarAlerta("Fecha inválida", `La fecha de programación no puede ser anterior a ${fecha_inicio}`, "warning");
      return;
    }
    if (fecha_final && this.actividadForm.fecha_programacion > fecha_final) {
      this.mostrarAlerta("Fecha inválida", `La fecha de programación no puede ser posterior a ${fecha_final}`, "warning");
      return;
    }
    if (this.actividadForm.fecha_ejecucion) {
      if (fecha_inicio && this.actividadForm.fecha_ejecucion < fecha_inicio) {
        this.mostrarAlerta("Fecha inválida", `La fecha de ejecución no puede ser anterior a ${fecha_inicio}`, "warning");
        return;
      }
      if (fecha_final && this.actividadForm.fecha_ejecucion > fecha_final) {
        this.mostrarAlerta("Fecha inválida", `La fecha de ejecución no puede ser posterior a ${fecha_final}`, "warning");
        return;
      }
    }

    const payloadPrincipal: CapacitacionActividadPayload = {
      id_capacitacion: this.idCapacitacionRuta,
      dirigido: Number(this.actividadForm.dirigido),
      responsable: this.actividadForm.responsable,
      fecha_programacion: this.actividadForm.fecha_programacion,
      hora_inicio: this.actividadForm.hora_inicio ?? (undefined as any),
      hora_fin: this.actividadForm.hora_fin ?? (undefined as any),
      fecha_ejecucion: this.actividadForm.fecha_ejecucion ?? (null as any),
      estado: Number(this.actividadForm.estado ?? 1),
    };

    this.loading = true;

    const peticionPrincipal = this.modoEdicion && this.actividadEditandoId
      ? this.actividadService.update(this.actividadEditandoId, payloadPrincipal)
      : this.actividadService.create(payloadPrincipal);

    peticionPrincipal.subscribe({
      next: (respuesta: any) => {
        const idActividad = this.modoEdicion
          ? this.actividadEditandoId!
          : Number(respuesta?.data?.id ?? respuesta?.id);

        if (!idActividad) {
          this.loading = false;
          Swal.fire({ icon: "error", title: "Error", text: "No se pudo determinar el id de la actividad creada." });
          return;
        }

        this.guardarSubActividades(idActividad, subActividadesValidas);
      },
      error: (error) => {
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar la actividad",
          text: error?.error?.message || "Revisa la información e inténtalo de nuevo.",
        });
      },
    });
  }

  private guardarSubActividades(idActividad: number, subActividadesValidas: SubActividadRow[]): void {
    const peticiones: Observable<any>[] = [];

    subActividadesValidas.forEach((sub) => {
      const payload: CapacitacionActividadRePayload = {
        id_actividad: idActividad,
        actividad: sub.actividad.trim().toUpperCase(),
        estado: 1,
      };

      peticiones.push(
        sub.id
          ? this.actividadReService.update(sub.id, payload)
          : this.actividadReService.create(payload)
      );
    });

    this.subActividadesEliminadas.forEach((id) => {
      peticiones.push(this.actividadReService.inactivar(id));
    });

    if (peticiones.length === 0) {
      this.finalizarGuardado();
      return;
    }

    forkJoin(peticiones).subscribe({
      next: () => this.finalizarGuardado(),
      error: () => {
        this.loading = false;
        Swal.fire({
          icon: "warning",
          title: "Actividad guardada con observaciones",
          text: "La actividad principal se guardó, pero hubo un problema con alguna actividad específica.",
        });
        this.modalRef?.close();
        this.cargarActividades();
      },
    });
  }

  private finalizarGuardado(): void {
    this.loading = false;
    this.modalRef?.close();
    Swal.fire({
      icon: "success",
      title: this.modoEdicion ? "Actividad actualizada" : "Actividad creada",
      text: this.modoEdicion ? "La actividad se actualizó correctamente." : "La actividad se creó correctamente.",
    });
    this.cargarActividades();
  }

  // ── Activar / inactivar cabecera ─────────────────────────────
  activarActividad(id: number | string | undefined): void {
    if (id == null) return;
    this.actividadService.activar(Number(id)).subscribe({
      next: () => {
        Swal.fire("Activada", "La actividad fue activada correctamente.", "success");
        this.cargarActividades();
      },
      error: () => { Swal.fire("Error", "No se pudo activar la actividad.", "error"); },
    });
  }

  inactivarActividad(id: number | string | undefined): void {
    if (id == null) return;
    Swal.fire({
      title: "¿Desea inactivar esta actividad?",
      text: "El registro quedará disponible en inactivos.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result: any) => {
      if (!result.isConfirmed) return;
      this.actividadService.inactivar(Number(id)).subscribe({
        next: () => {
          Swal.fire("Inactivada", "La actividad fue inactivada correctamente.", "success");
          this.cargarActividades();
        },
        error: () => { Swal.fire("Error", "No se pudo inactivar la actividad.", "error"); },
      });
    });
  }

  // ── Exportar ─────────────────────────────────────────────────
  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any): void {
    Swal.fire({ title: titulo, text: mensaje, icon: icono, confirmButtonColor: "#3085d6" });
  }

  // =====================================================================
  // ── SEGUIMIENTOS (capacitacion_actividad_ejecucion) ──────────────────
  // Mismo patrón que PasosPlanComponent: modal-listado + modal-form + modal-documentos
  // =====================================================================

  inicializarFormSeguimiento(): void {
    this.seguimientoForm = this.fb.group({
      observaciones: ["", [Validators.required, Validators.maxLength(3000)]],
    });
  }

  abrirModalSeguimientos(item: CapacitacionActividad, content: TemplateRef<any>): void {
    if (!item?.id) return;

    this.idActividadSeguimientos = Number(item.id);
    this.actividadSeguimientosActiva = this.esActivo(item);
    this.nombreActividadSeguimientos = (item as any)?.dirigido_nombre ?? this.nombreCapacitacionRuta;

    this.cargarSeguimientos(this.idActividadSeguimientos);

    this.modalSeguimientosRef = this.modalService.open(content, {
      size: "lg",
      backdrop: "static",
    });
  }

  cargarSeguimientos(idActividad: number): void {
    this.cargandoSeguimientos = true;
    this.actividadEjecucionService.getAll().subscribe({
      next: (data) => {
        this.listaSeguimientos = (data ?? [])
          .filter((s) => Number(s.id_actividad) === Number(idActividad))
          .sort((a: any, b: any) =>
            new Date(b.fechaCreacion ?? 0).getTime() - new Date(a.fechaCreacion ?? 0).getTime()
          );
        this.cargandoSeguimientos = false;
      },
      error: () => {
        this.listaSeguimientos = [];
        this.cargandoSeguimientos = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los seguimientos." });
      },
    });
  }

abrirModalSeguimientoForm(modalRef: any, seguimiento?: CapacitacionActividadEjecucion): void {
  if (!this.actividadSeguimientosActiva) {
    Swal.fire({
      icon: "warning",
      title: "Actividad inactiva",
      text: "No se pueden crear ni editar seguimientos de una actividad inactiva.",
    });
    return;
  }

  this.seguimientoEditando = seguimiento || null;
  this.seguimientoForm.reset();

  if (seguimiento) {
    this.seguimientoForm.patchValue({ observaciones: seguimiento.observaciones });
  }

  this.modalService.open(modalRef, { size: "lg", backdrop: "static" });
}

guardarSeguimiento(modal: any): void {
  if (!this.actividadSeguimientosActiva) {
    Swal.fire({ icon: "warning", title: "Actividad inactiva", text: "No se pueden guardar seguimientos de una actividad inactiva." });
    return;
  }
  if (this.seguimientoForm.invalid) {
    this.seguimientoForm.markAllAsTouched();
    return;
  }
    if (!this.idActividadSeguimientos) {
      Swal.fire({ icon: "error", title: "Error", text: "No se identificó la actividad asociada." });
      return;
    }

    this.guardandoSeguimiento = true;
    const idActividad = this.idActividadSeguimientos;
    const observaciones = (this.seguimientoForm.value.observaciones || "").trim();

    // ⚠️ update(...) asume que CapacitacionActividadEjecucionService lo implementa
    // (ver nota al final de la respuesta)
    const peticion = this.seguimientoEditando?.id
      ? this.actividadEjecucionService.update(this.seguimientoEditando.id, {
          id_actividad: idActividad,
          observaciones,
        } as CapacitacionActividadEjecucionPayload)
      : this.actividadEjecucionService.create({
          id_actividad: idActividad,
          observaciones,
          estado: 1,
        } as CapacitacionActividadEjecucionPayload);

    const mensajeExito = this.seguimientoEditando ? "Seguimiento actualizado" : "Seguimiento guardado";

    peticion.subscribe({
      next: () => {
        this.guardandoSeguimiento = false;
        modal.close();
        this.cargarSeguimientos(idActividad);
        Swal.fire({ icon: "success", title: mensajeExito, timer: 1500, showConfirmButton: false });
      },
      error: () => {
        this.guardandoSeguimiento = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo guardar el seguimiento." });
      },
    });
  }

  // ⚠️ activar/inactivar asumen que el servicio los implementa (reemplaza al remove físico anterior)
  cambiarEstadoSeguimiento(seguimiento: CapacitacionActividadEjecucion): void {
    if (!seguimiento.id || !this.idActividadSeguimientos) return;
    const idActividad = this.idActividadSeguimientos;
    const accion = Number((seguimiento as any).estado ?? 1) === 1 ? "Inactivar" : "Activar";

    Swal.fire({
      icon: "question",
      title: `¿${accion} seguimiento?`,
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const peticion =
        Number((seguimiento as any).estado ?? 1) === 1
          ? this.actividadEjecucionService.inactivar(seguimiento.id!)
          : this.actividadEjecucionService.activar(seguimiento.id!);

      peticion.subscribe({
        next: () => {
          this.cargarSeguimientos(idActividad);
          Swal.fire({ icon: "success", title: "Estado actualizado", timer: 1200, showConfirmButton: false });
        },
        error: () => Swal.fire({ icon: "error", title: "Error", text: "No se pudo cambiar el estado." }),
      });
    });
  }

  // =====================================================================
  // ── DOCUMENTOS DEL SEGUIMIENTO (mismo patrón que PasosPlanComponent) ──
  // Ruta: {nit}/capacitaciones/{idCapacitacion}/{idActividad}/seguimientos/{idSeguimiento}
  // =====================================================================

  abrirModalDocumentosSeguimiento(modalRef: any, seguimiento: CapacitacionActividadEjecucion): void {
    if (!this.nit) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Aún se está cargando la información de la empresa. Intenta de nuevo en un momento.",
      });
      return;
    }

    this.seguimientoSeleccionadoDocs = seguimiento;
    this.nuevosArchivosDocs = [];
    this.documentosSeguimiento = [];
    this.mostrandoPreviewDocumento = false;
    this.documentoSeleccionado = null;

    this.cargarDocumentosSeguimiento(seguimiento);

    this.modalService.open(modalRef, { size: "lg", centered: true, backdrop: "static" });
  }

  cargarDocumentosSeguimiento(seguimiento: CapacitacionActividadEjecucion): void {
    if (!this.nit) return;

    this.cargandoDocumentos = true;
    const rutaCompleta = this.construirRutaSeguimiento(seguimiento);

    this.digitalesService.getDocumentosPlanAccion(rutaCompleta).subscribe({
      next: (resp: any) => {
        this.documentosSeguimiento = (resp?.archivos ?? []).map((a: any) => ({
          name: a.name,
          path: a.path,
          url: a.url,
          isImage: this.esImagenPorNombre(a.name),
        }));
        this.cargandoDocumentos = false;
      },
      error: () => {
        this.documentosSeguimiento = [];
        this.cargandoDocumentos = false;
      },
    });
  }

  onFileChangeDocumento(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.nuevosArchivosDocs.push({
          file,
          preview: this.isImageFile(file) ? e.target.result : null,
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = "";
  }

  quitarArchivoNuevo(index: number): void {
    this.nuevosArchivosDocs.splice(index, 1);
  }
subirDocumentosSeguimiento(): void {
  const seguimiento = this.seguimientoSeleccionadoDocs;
  if (
    !seguimiento ||
    !this.actividadSeguimientosActiva ||
    Number((seguimiento as any).estado ?? 1) === 0 ||
    this.nuevosArchivosDocs.length === 0 ||
    !this.nit
  ) {
    return;
  }

    this.subiendoDocumentos = true;
    const rutaCompleta = this.construirRutaSeguimiento(seguimiento);
    const pendientes = this.nuevosArchivosDocs.length;
    let completados = 0;

    this.nuevosArchivosDocs.forEach((item, index) => {
      const nombreSinExtension = item.file.name.replace(/\.[^/.]+$/, "");
      const sufijoUnico = `${Date.now()}_${index}_${Math.floor(Math.random() * 10000)}`;
      const nombreArchivo = `${nombreSinExtension}_${sufijoUnico}`;

      this.digitalesService
        .subirDocumentoPlanAccion(item.file, rutaCompleta, nombreArchivo, "capacitacion_actividad_seguimiento")
        .subscribe({
          next: (event) => {
            if (event.type === HttpEventType.Response) {
              completados++;
              if (completados === pendientes) {
                this.subiendoDocumentos = false;
                this.nuevosArchivosDocs = [];
                this.cargarDocumentosSeguimiento(seguimiento);
                Swal.fire({ icon: "success", title: "¡Éxito!", text: "Documento(s) subido(s) correctamente." });
              }
            }
          },
          error: () => {
            completados++;
            this.subiendoDocumentos = false;
            if (completados === pendientes) {
              this.cargarDocumentosSeguimiento(seguimiento);
            }
            Swal.fire({ icon: "error", title: "Error", text: `No se pudo subir el archivo ${item.file.name}.` });
          },
        });
    });
  }

eliminarDocumentoSeguimiento(doc: DocumentoAdjunto): void {
  const seguimiento = this.seguimientoSeleccionadoDocs;
  if (!seguimiento || !this.actividadSeguimientosActiva || Number((seguimiento as any).estado ?? 1) === 0) {
    Swal.fire({ icon: "warning", title: "Acción no permitida", text: "No se puede eliminar documentos de un seguimiento o actividad inactiva." });
    return;
  }

    Swal.fire({
      title: "¿Eliminar documento?",
      text: `¿Está seguro de que desea eliminar "${doc.name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.digitalesService.eliminarArchivo(doc.path).subscribe({
        next: () => {
          this.cargarDocumentosSeguimiento(seguimiento);
          Swal.fire({ icon: "success", title: "¡Éxito!", text: "El documento se eliminó correctamente." });
        },
        error: () => { Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar el documento." }); },
      });
    });
  }

reemplazarDocumentoSeguimiento(doc: DocumentoAdjunto): void {
  const seguimiento = this.seguimientoSeleccionadoDocs;
  if (!seguimiento || !this.actividadSeguimientosActiva || Number((seguimiento as any).estado ?? 1) === 0) {
    Swal.fire({ icon: "warning", title: "Acción no permitida", text: "No se puede reemplazar documentos de un seguimiento o actividad inactiva." });
    return;
  }

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".pdf,.jpg,.jpeg,.png,.webp";

    input.onchange = (event: any) => {
      const file: File = event.target.files[0];
      if (!file) return;

      Swal.fire({
        title: "¿Reemplazar documento?",
        text: `Se reemplazará "${doc.name}" por "${file.name}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, reemplazar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.subiendoDocumentos = true;

        this.digitalesService.eliminarArchivo(doc.path).subscribe({
          next: () => {
            const rutaCompleta = this.construirRutaSeguimiento(seguimiento);
            const indice = this.documentosSeguimiento.findIndex((d) => d.path === doc.path) + 1;
            const nombreArchivo = `${seguimiento.id}_${indice}`;

            this.digitalesService
              .subirDocumentoPlanAccion(file, rutaCompleta, nombreArchivo, "capacitacion_actividad_seguimiento")
              .subscribe({
                next: (event) => {
                  if (event.type === HttpEventType.Response) {
                    this.subiendoDocumentos = false;
                    this.cargarDocumentosSeguimiento(seguimiento);
                    Swal.fire({ icon: "success", title: "¡Éxito!", text: "Documento reemplazado correctamente." });
                  }
                },
                error: () => {
                  this.subiendoDocumentos = false;
                  Swal.fire({ icon: "error", title: "Error", text: "No se pudo subir el nuevo documento." });
                },
              });
          },
          error: () => {
            this.subiendoDocumentos = false;
            Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar el documento anterior." });
          },
        });
      });
    };

    input.click();
  }

  verDocumento(doc: DocumentoAdjunto): void {
    if (!doc.url) return;

    const tipo = this.obtenerTipoDocumento(doc.name);

    this.documentoSeleccionado = {
      ...doc,
      isImage: tipo === "imagen",
      isPdf: tipo === "pdf",
      tipo,
      urlSegura: tipo === "pdf" ? this.sanitizer.bypassSecurityTrustResourceUrl(doc.url) : undefined,
    };

    this.mostrandoPreviewDocumento = true;
  }

  cerrarPreviewDocumento(): void {
    this.mostrandoPreviewDocumento = false;
    this.documentoSeleccionado = null;
  }

  private construirRutaSeguimiento(seguimiento: CapacitacionActividadEjecucion): string {
    const carpeta = `capacitaciones/${this.idCapacitacionRuta}/${this.idActividadSeguimientos}/seguimientos/${seguimiento.id}`;
    return `${this.nit}/${carpeta}`;
  }

  private esImagenPorNombre(nombre: string): boolean {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    return EXTENSIONES_IMAGEN.includes(ext);
  }

  private isImageFile(file: File): boolean {
    return MIME_IMAGEN.includes(file.type);
  }

  private obtenerTipoDocumento(nombre: string): "imagen" | "pdf" | "word" | "excel" | "otro" {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    if (EXTENSIONES_IMAGEN.includes(ext)) return "imagen";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";
    return "otro";
  }

  // ===================== RESUMEN (tarjetas superiores) =====================

get totalActividades(): number {
  return this.actividades.length;
}

get totalActivasCount(): number {
  return this.actividades.filter((a) => this.esActivo(a)).length;
}

get proximaActividadProgramada(): CapacitacionActividad | undefined {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  return [...this.actividades]
    .filter((a) => this.esActivo(a) && a.fecha_programacion)
    .map((a) => ({ item: a, fecha: new Date(a.fecha_programacion as any) }))
    .filter((x) => x.fecha.getTime() >= hoy.getTime())
    .sort((a, b) => a.fecha.getTime() - b.fecha.getTime())[0]?.item;
}
}